export default __webpack_public_path__ + "static/media/wife2.bcc866e0.png";